import type { LearnerQuestion } from "../../../packages/content-schema";
import { readDraft, writeDraft, pruneQuestionCaches } from "./draft-storage";
type Cache = Array<{ id: string; question: LearnerQuestion }>;
// Loaded only after the attempt endpoint has revalidated the current account.
export async function cachedQuestion(userId: string, releaseId: string, id: string) {
  return (await readDraft<Cache>(`${userId}:questions:${releaseId}`).catch(() => undefined))?.find((entry) => entry.id === id)?.question;
}
export async function cacheQuestion(userId: string, releaseId: string, question: LearnerQuestion) {
  const key = `${userId}:questions:${releaseId}`;
  const existing = await readDraft<Cache>(key) ?? [];
  if (existing.some((entry) => entry.id === question.id && entry.question.revision === question.revision)) return;
  const cache = existing.filter((entry) => entry.id !== question.id);
  cache.push({ id: question.id, question });
  while (cache.length > 30 || (cache.length && new TextEncoder().encode(JSON.stringify(cache)).length > 4 * 1024 * 1024)) cache.shift();
  await writeDraft(key, cache);
  await pruneQuestionCaches(userId, key);
}
